module.exports = __webpack_public_path__ + "img/guadalajara.a5dc1a30.jpg";